/**
 * User role and permission constants
 * Each role corresponds to one permission - user can assume roles they have permission for
 */

export const USER_ROLE_OPTIONS = [
  { value: "admin", label: "Admin", permission: "admin" },
  { value: "triage_officer", label: "Triage Officer", permission: "triage_officer" },
  {
    value: "department_assessor",
    label: "Department Assessor",
    permission: "department_assessor",
  },
  {
    value: "department_approver",
    label: "Department Approver",
    permission: "department_approver",
  },
] as const;

export type UserRole = (typeof USER_ROLE_OPTIONS)[number]["value"];
export type UserPermission = (typeof USER_ROLE_OPTIONS)[number]["permission"];

/** All valid role values */
export const ALL_USER_ROLES: readonly UserRole[] = USER_ROLE_OPTIONS.map(
  (opt) => opt.value
);
